// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"3e6cb708","139":"05472cf3","653":"072aeb4e","961":"0a24d577"}[chunkId] + ".chunk.js";
};